export const faqData = [
  {
    question: "How to pay with Telegram?",
    answer: (
      <span>
        Purchasing our subscription through Telegram is a simple two-step
        process: 1. You purchase Stars (via the official{" "}
        <a
          href="https://t.me/PremiumBot"
          target="_blank"
          rel="noreferrer"
          style={{ color: "#2877d9", textDecoration: "none" }}
          onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
          onMouseOut={(e) => (e.target.style.textDecoration = "none")}
        >
          @PremiumBot
        </a>
        ) from Telegram using your card (or Google Pay, Apple Pay, or other
        methods). 2. You use the Stars you purchased to buy our service (by
        paying the Stars to our bot).
        <br />
        <br />
        For detailed step-by-step guidance, please refer to our Telegram Payment{" "}
        <a
          href="/telegram-tutorial"
          style={{ color: "#2877d9", textDecoration: "none" }}
          onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
          onMouseOut={(e) => (e.target.style.textDecoration = "none")}
        >
          Tutorial
        </a>
        .
      </span>
    ),
  },
  {
    question: "How to pay with Crypto?",
    answer: (
      <span>
        For crypto payments, we accept top-ups of any amount, but for top-ups
        less than $10, the actual credits you receive will be slightly less than
        expected due to the fees of the payment channel.
        <br />
        <br />
        Please make sure you have paid the full amount of currency (after
        deducting network fees) and confirmed that you selected the correct coin
        and network when making a payment to avoid your payment being held.
        <br />
        <br />
        For detailed step-by-step guidance, please refer to our Crypto Payment{" "}
        <a
          href="/crypto-tutorial"
          style={{ color: "#2877d9", textDecoration: "none" }}
          onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
          onMouseOut={(e) => (e.target.style.textDecoration = "none")}
        >
          Tutorial
        </a>
        .
      </span>
    ),
  },
  {
    question: "How long does it take for purchased credits to arrive?",
    answer:
      "Telegram Stars payments usually arrive instantly (within 1 minute).",
  },
  {
    question: "Why didn't the credits arrive after I purchased via Telegram?",
    answer:
      "If your credits haven't arrived after purchasing via Telegram, please check your transaction history first. If the transaction shows as completed but credits are missing, contact our support team with your transaction ID.",
  },
  {
    question: "What is the validity period of my subscription or credits?",
    answer:
      "All credits are valid for 30 days, including those obtained through subscriptions, top-ups, check-ins and referrals. Annual subscriptions are distributed as 12 consecutive monthly allocations, with new credits added on the same day each month.",
  },
  {
    question: "How can I cancel my subscription?",
    answer:
      "Cancellation is not required, as the subscription does not automatically renew. Your subscription will remain active until the end of the current billing period, and you'll retain access to all features until then.",
  },
  {
    question: "How do I delete my account?",
    answer: (
      <span>
        If you wish to permanently delete your account, you can do so by
        visiting our{" "}
        <a
          href="/account/delete"
          style={{
            color: "#2877d9",
            textDecoration: "none",
          }}
          onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
          onMouseOut={(e) => (e.target.style.textDecoration = "none")}
        >
          account deletion page
        </a>
        . Please note that this action is permanent and will erase all your
        credits, videos, and personal data. This cannot be undone.
      </span>
    ),
  },
];
